import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  StyledWarningCtaMultiplePF,
  StyledMixedJourneyContainer,
  StyledMixedJourney,
  StyledWarningCtaMultiplePFSpan,
  StyledPF
} from './WarningCta.styles';

const WarningCtaMultiplePF = ({ productFamiliesPerPassengersInMixedPF = {} }) => (
  <StyledWarningCtaMultiplePF>
    {productFamiliesPerPassengersInMixedPF.outbound?.length > 0 && (
      <StyledMixedJourneyContainer>
        <StyledMixedJourney>
          {' '}
          <FormattedMessage id="addAssistance.journey.outbound" />:{' '}
        </StyledMixedJourney>
        <div>
          {productFamiliesPerPassengersInMixedPF.outbound.map((s, index) => (
            <StyledWarningCtaMultiplePFSpan key={`${s.ticketNumber}--${index}`}>
              <StyledPF>{s.productFamily}</StyledPF> -{' '}
              <StyledPF>
                <FormattedMessage id="clubEurostar.ticketNumber" />:
              </StyledPF>{' '}
              {s.ticketNumber} -{' '}
              <StyledPF>
                <FormattedMessage id="reviewScreen.passenger" />:
              </StyledPF>{' '}
              {s.passengerId} ({s.passenger?.firstName} {s.passenger?.lastName})
            </StyledWarningCtaMultiplePFSpan>
          ))}
        </div>
      </StyledMixedJourneyContainer>
    )}

    {productFamiliesPerPassengersInMixedPF.inbound?.length > 0 && (
      <StyledMixedJourneyContainer>
        <StyledMixedJourney>
          {' '}
          <FormattedMessage id="addAssistance.journey.inbound" />:{' '}
        </StyledMixedJourney>
        <div>
          {productFamiliesPerPassengersInMixedPF.inbound.map((s, index) => (
            <StyledWarningCtaMultiplePFSpan key={`${s.ticketNumber}--${index}`}>
              <StyledPF>{s.productFamily}</StyledPF> -{' '}
              <StyledPF>
                <FormattedMessage id="clubEurostar.ticketNumber" />:
              </StyledPF>{' '}
              {s.ticketNumber} -{' '}
              <StyledPF>
                <FormattedMessage id="reviewScreen.passenger" />:
              </StyledPF>{' '}
              {s.passengerId} ({s.passenger?.firstName} {s.passenger?.lastName})
            </StyledWarningCtaMultiplePFSpan>
          ))}
        </div>
      </StyledMixedJourneyContainer>
    )}
  </StyledWarningCtaMultiplePF>
);

WarningCtaMultiplePF.propTypes = {
  productFamiliesPerPassengersInMixedPF: PropTypes.arrayOf(
    PropTypes.shape({
      passengerId: PropTypes.string,
      ticketNumber: PropTypes.string,
      productFamily: PropTypes.string,
      passenger: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string
      })
    })
  )
};

export default WarningCtaMultiplePF;
